module.exports = __webpack_public_path__ + "static/media/Template_16.c4ae92aa.png";